import { Message, MessageHeaderProps, MessageItemProps, MessageListProps, MessageProps } from "semantic-ui-react";

type BPMessageProps = MessageProps & {}

export function BPMessage(props: BPMessageProps) {
    return <Message {...props}>
        {props.children}
    </Message>;
}

type BPMessageHeaderProps = MessageHeaderProps & {}

export function BPMessageHeader(props: BPMessageHeaderProps) {
    return <Message.Header {...props}>
        {props.children}
    </Message.Header>;
}

type BPMessageListProps = MessageListProps & {}

export function BPMessageList(props: BPMessageListProps) {
    return <Message.List {...props}>
        {props.children}
    </Message.List>;
}

type BPMessageItemProps = MessageItemProps & {}

export function BPMessageItem(props: BPMessageItemProps) {
    return <Message.Item {...props}>
        {props.children}
    </Message.Item>;
}